var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProfileLight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 87,
    height: 84,
    viewBox: "0 0 87 84",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M43.5 2.29297C21.0682 2.29297 2 20.3962 2 42.0559C2 63.7155 21.0682 81.8188 43.5 81.8188C65.9318 81.8188 85 63.7155 85 42.0559C85 20.3962 65.9318 2.29297 43.5 2.29297ZM43.5 25.1744C49.3032 25.1744 53.35 29.1667 53.35 34.5033C53.35 39.8399 49.3032 43.8322 43.5 43.8322C37.7002 43.8322 33.65 39.8395 33.65 34.5033C33.65 29.1671 37.7002 25.1744 43.5 25.1744ZM43.5 66.4899C36.736 66.4899 30.6034 63.971 26.0245 59.8852C29.2587 56.1684 34.0892 53.7685 39.55 53.7685H47.45C52.9141 53.7685 57.7419 56.1682 60.9756 59.8852C56.3967 63.971 50.2641 66.4899 43.5 66.4899Z",
    fill: "#003777",
    stroke: "white",
    strokeWidth: 4
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileLight);
export default __webpack_public_path__ + "static/media/profile-light.e9686f230f34f7cab60b1e65aebda2bc.svg";
export { ForwardRef as ReactComponent };